import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NgbModule, NgbAlertModule, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import { InputMaskModule } from "ngx-input-mask";
import { CommonModule, DatePipe } from '@angular/common';
// import { NgxCollapseModule } from 'ngx-collapse';
// import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { EnrollmentFormComponent } from './enrollment-form/enrollment-form.component';
import { InterceptorService } from './services/interceptor.service';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './modules/terms-condition/terms-condition.component';
import { ContactUsComponent } from './modules/contact-us/contact-us.component';
// import { NgxCaptchaModule } from 'ngx-captcha';
// import { RecaptchaModule } from 'ng-recaptcha';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { MaterialModule } from './material.module';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from "@progress/kendo-angular-label";
import { IndicatorsModule } from "@progress/kendo-angular-indicators";
import { companyInformation } from './enrollment-form/companyInformation/companyInformation.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { MatTooltipModule } from '@angular/material/tooltip';
import { DownloadEnrollmentProfileComponent } from './enrollment-form/download-enrollment-profile/download-enrollment-profile.component';
import { ServiceAgreementComponent } from './components/service-agreement/service-agreement.component';
import { ServiceAgreementPdfComponent } from './components/service-agreement-pdf/service-agreement-pdf.component';


// import {ActivatedRoute} from '@angular/router'
@NgModule({ declarations: [
        AppComponent,
        EnrollmentFormComponent,
        ServiceAgreementComponent, 
        ServiceAgreementPdfComponent,
        PrivacyPolicyComponent,
        TermsConditionComponent,
        ContactUsComponent,
        HeaderComponent,
        FooterComponent,
        companyInformation,
        DownloadEnrollmentProfileComponent
    ],
    bootstrap: [AppComponent], imports: [NgbAlertModule,
        NgbModalModule,
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        // NgxCollapseModule,
        // NgxSpinnerModule,
        BrowserAnimationsModule,
        // NgxCaptchaModule,
        // RecaptchaModule,
        MaterialModule,
        InputsModule,
        DropDownsModule,
        LabelModule,
        GridModule,
        PDFExportModule,
        IndicatorsModule], providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        }, DatePipe, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
